import * as React from 'react';

import { DeclarationAcceptance } from '../containers';

export const DeclarationAcceptancePage = () => {
  return <DeclarationAcceptance />;
};
